import { render, staticRenderFns } from "./CancelAppointmentModal.vue?vue&type=template&id=93221240&scoped=true&"
import script from "./CancelAppointmentModal.vue?vue&type=script&lang=ts&"
export * from "./CancelAppointmentModal.vue?vue&type=script&lang=ts&"
import style0 from "./CancelAppointmentModal.vue?vue&type=style&index=0&id=93221240&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93221240",
  null
  
)

export default component.exports